.cardActionLinkText {
    color: var(--card-action-link-text-color);
    font-size: var(--card-action-link-text-font-size);
    font-weight: var(--card-action-link-text-font-weight);
}
